import { apiSlice } from './apiSlice';

/**
 * `GET /v3/transaction/history/` — the signed-in trader's
 * purchases, paginated: `{ count, next, previous, page_number, page_size,
 * results[] }`. `next`/`previous` are page numbers, not URLs.
 *
 * Row fields, as the page reads them: `Funding_evaluation` (plan),
 * `Account_balance`, `payment_id`, `date`, `amount` (minor units),
 * `payment_status`, `invoice` (URL or "N/A"), `meta_data` (JSON string).
 */
export const transactionsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTransactions: builder.query({
      query: (params) => {
        const { ordering, ...rest } = params ?? {};
        return {
          url: '/v3/transaction/history/',
          params: { page: 1, page_size: 10, ...rest },
        };
      },
      providesTags: ['Transaction'],
    }),

    /**
     * `GET /v2/transaction/history/export/` — the same history as a file, so the
     * response is taken as a blob rather than JSON. Narrowed by `start_date` /
     * `end_date` / `status`; unset ones are dropped by `cleanObject`.
     */
    exportTransactions: builder.query({
      query: (params) => ({
        url: '/v2/transaction/history/export/',
        params,
        // Content-Disposition is not an exposed CORS header, so the caller
        // names the file itself.
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export const { useGetTransactionsQuery, useLazyExportTransactionsQuery } = transactionsApi;
